import { debug, george, observer, pr, React, theme, ui } from "aaa";
import { addressToString } from "stores/ContactsStore";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";
import { CardTanSettingsStore } from "./CardTanSettingsStore";

type IProps = {
    store: CardTanSettingsStore;
};

@observer
export class CardTanSettingsNewDeviceSigning extends React.Component<IProps, {}> {
    render() {
        const signInfo = this.props.store.orderNewCardTanReaderResponse?.signInfo;

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>

                            <pr.LightSeparatorLine spacing={theme.MARGIN} />

                            <george.ResponsiveSummaryElement label={ui.__("cardTanSettings.newDevice.signing.product.label")}>
                                <pr.SigningLabel>{ui.__("cardTanSettings.newDevice.signing.product")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>

                            <george.ResponsiveSummaryElement label={ui.__("cardTanSettings.newDevice.signing.price.label")}>
                                <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>
                            </george.ResponsiveSummaryElement>

                            <george.ResponsiveSummaryElement label={ui.__("cardTanSettings.newDevice.signing.deliveryAddress.label")}>
                                <pr.SigningLabel>
                                    {this.props.store.contactsStore.selectedAddress && addressToString(this.props.store.contactsStore.selectedAddress)}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                        </div>
                        <div>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <div style={{ padding: theme.MARGIN }}>
                                <pr.SigningApproval>
                                    {ui.__("cardTanSettings.newDevice.signing.approval.text")}
                                </pr.SigningApproval>
                            </div>
                        </div>
                    </>
                }

                onError={async (response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    this.props.store.isLoadingCardTanReaderOfferFinished = false;
                    this.props.store.loadCardTanReaderOfferAndPrice();
                    pushRoute("/error");
                }}

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    this.props.store.isLoadingCardTanReaderOfferFinished = false;
                    this.props.store.loadCardTanReaderOfferAndPrice();
                    pushRoute(CardTanSettingsRoutes.NEW_DEVICE_SUCCESS);
                }}

                onClose={async () => {
                    history.goBack();
                }}

                onRetry={async () => {
                    await this.props.store.changePin();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsNewDeviceSigning.tsx